import { Injectable } from '@angular/core';

declare let slab_AB: any;
declare let pg_paypal_AB: any;

@Injectable({
  providedIn: 'root'
})
export class ABService {

  constructor() { }

  slab_AB() {
    if (typeof slab_AB !== 'undefined') {
      return slab_AB;
    }
  }

  pg_paypal_AB() {
    const sessionData = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('pg_paypal_AB') : undefined;
    if (sessionData) {
      return sessionData;
    }
    if (typeof pg_paypal_AB !== 'undefined') {
      sessionStorage.setItem('pg_paypal_AB', pg_paypal_AB);
      return pg_paypal_AB;
    }
  }
}
